import React from 'react';
import { useStore } from '../store';
import { ZONES, WORLD } from '../config/zones';

const R = 58; // usable radius in px
const XMAX = 210;
const ZMAX = 125;

export default function Minimap() {
  const [px, pz] = useStore((s) => s.playerPos);
  const yaw = useStore((s) => s.playerYaw);
  const currentZone = useStore((s) => s.currentZone);
  const tourActive = useStore((s) => s.tourActive);

  const toXY = (x, z) => ({ left: 64 + (x / XMAX) * R, top: 64 + (z / ZMAX) * R });
  const player = toXY(px, pz);

  return (
    <div data-testid="minimap" className="relative w-32 h-32 rounded-full glass overflow-hidden pointer-events-auto">
      {/* Liberal (Navy, top) / Conservative (Red, bottom) halves */}
      <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(30,58,138,0.45), rgba(0,0,0,0) 42%, rgba(0,0,0,0) 58%, rgba(220,38,38,0.42))' }} />
      {/* River band (Sky Blue) */}
      <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-2.5" style={{ background: 'rgba(56,189,248,0.7)' }} />

      {/* Bank labels */}
      <span className="absolute top-2 left-1/2 -translate-x-1/2 font-mono text-[8px] tracking-widest" style={{ color: '#93c5fd' }}>LIBERAL</span>
      <span className="absolute bottom-2 left-1/2 -translate-x-1/2 font-mono text-[8px] tracking-widest" style={{ color: '#fca5a5' }}>CONSERVATIVE</span>

      {/* Zone markers + labels along the river */}
      {ZONES.map((z) => {
        const p = toXY(z.x, 0);
        const active = tourActive && z.index === currentZone;
        return (
          <div key={z.id} className="absolute" style={{ left: p.left, top: p.top, transform: 'translate(-50%,-50%)' }}>
            <div className="rounded-full" style={{
              width: active ? 7 : 4, height: active ? 7 : 4,
              background: active ? '#D4AF37' : 'rgba(255,255,255,0.55)',
              boxShadow: active ? '0 0 8px #D4AF37' : 'none',
            }} />
            {active && (
              <span className="absolute left-1/2 -translate-x-1/2 -top-3 whitespace-nowrap font-mono text-[7px] text-gold">{z.number}</span>
            )}
          </div>
        );
      })}

      {/* Player indicator (high-contrast, always visible in storm/night) */}
      <div className="absolute" style={{ left: player.left, top: player.top, transform: `translate(-50%,-50%) rotate(${-yaw}rad)` }}>
        <div style={{ width: 0, height: 0, borderLeft: '6px solid transparent', borderRight: '6px solid transparent', borderBottom: '12px solid #ffffff', filter: 'drop-shadow(0 0 4px #D4AF37)' }} />
      </div>

      {/* Crosshair ring */}
      <div className="absolute inset-1 rounded-full border border-white/15 pointer-events-none" />
    </div>
  );
}
